import React, { useState } from "react";
import { successMsg } from "../SuccessHandler";
import ErrorCodes from "../../constants/ErrorCodes";
import SiteConfig from "../../constants/SiteConfig";
import { useInsertFunctions } from "../../functions/InsertFunctions";

const CopyBookModal = ({
  isOpen,
  onClose,
  data,
  books,
  bookOptionSelected,
  setSessionNoLongerExists,
  publicIP,
}) => {
  const [copyBooksList, setCopyBooksList] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const { copyTracksByBook } = useInsertFunctions();

  // The name of the selected book is obtained
  let bookName = "";
  books.forEach((book) => {
    if (bookOptionSelected === book.IDBook) {
      bookName = book.Description;
    }
  });

  const booksChangeHandler = (IDBookSet) => {
    setCopyBooksList((prevBooks) => {
      const bookIndex = prevBooks.findIndex(
        (book) => book.CopySetID === IDBookSet,
      );
      if (bookIndex !== -1) {
        // The trackID already exists and must be deleted.
        return prevBooks.filter((book) => book.CopySetID !== IDBookSet);
      } else {
        // The trackID does not exist, it must be added.
        return [
          ...prevBooks,
          {
            CopyGetID: bookOptionSelected,
            CopySetID: IDBookSet,
          },
        ];
      }
    });
    setHasChanges(true);
  };

  // Headers
  let headers,
    tableBooks = [];
  headers = (
    <tr className="text-center" style={{ cursor: "default" }}>
      <th hidden>IDBook</th>
      <th>Book Name</th>
    </tr>
  );

  // The main Books table
  if (books) {
    tableBooks = books
      .filter((item) => item.IDBook !== bookOptionSelected)
      .map((item) => {
        const className = copyBooksList.some(
          (copyItem) => copyItem.CopySetID === item.IDBook,
        )
          ? "shadedRow"
          : "";

        return (
          <tr
            key={item.IDBook}
            onClick={() => booksChangeHandler(item.IDBook)}
            className={className}
            style={{ cursor: "pointer" }}
          >
            <td className="d-none">{item.IDBook}</td>
            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
              {item.Description}
            </td>
          </tr>
        );
      });
  }

  // This function is executed when user clicks on Copy button
  const handleCopyTracksByBook = async (copyList) => {
    if (hasChanges) {
      const res = await copyTracksByBook(
        {
          LastModification: new Date().toISOString(),
          List: copyList,
          PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
          IP: publicIP,
        },
        data.LogonSessionID,
      );

      if (res?.error) {
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        }
        return;
      } else {
        successMsg("Copy Tracks By Book");
        setCopyBooksList([]);
        setHasChanges(false);
        onClose();
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal d-block show"
      role="dialog"
      aria-modal="true"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 1051,
      }}
    >
      <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
        <div className="modal-content">
          <div
            className="modal-header"
            style={{ backgroundColor: "#5b6671", color: "#fff" }}
          >
            <h5 className="modal-title" style={{ cursor: "default" }}>
              Copy Tracks by Book
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => {
                setCopyBooksList([]);
                onClose();
              }}
              aria-label="Close"
            >
              &times;
            </button>
          </div>

          <div className="modal-body">
            <p
              className="lead"
              style={{
                color: "#8c8c8c",
                fontSize: "16px",
                textAlign: "center",
                cursor: "default",
              }}
            >
              Specify which Books will have the same configuration from Book:
            </p>
            <p
              style={{
                textAlign: "center",
                color: "#1cc8e3",
                fontWeight: "bold",
                fontSize: "18px",
                marginBottom: "10px",
                cursor: "default",
              }}
            >
              {bookName}
            </p>
            <div
              style={{
                maxHeight: "350px",
                overflowY: "auto",
              }}
            >
              <table className="table table-hover table-sm mt-2">
                <thead
                  style={{
                    position: "sticky",
                    top: "0",
                    background: "#d9d9d9",
                    zIndex: 1,
                  }}
                >
                  {headers}
                </thead>
                <tbody className="table-lg">{tableBooks}</tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleCopyTracksByBook(copyBooksList)}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setCopyBooksList([]);
                onClose();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyBookModal;
